import Glide from '@glidejs/glide';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    const gliders = document.querySelectorAll('.glide.variant');
    const slide = document.querySelectorAll('.glide__slide')[0];
    const carousels = [];
		const gotoSlide = function(instance, target){
			return new Promise(function(resolve){
				instance.go(target)
				resolve('moved')
			})
		}

    if (slide !== undefined) {
      gliders.forEach((glide) => {
        const carousel = new Glide(glide, {
          perView: 1,
          bound: true,
          slideWidth: slide.clientWidth,
          gap: glide.clientWidth / 100 * 3,
        })

				carousels.push(carousel);

				glide.parentNode.querySelectorAll('.color-links .link').forEach((arrow) => {
					if (arrow.dataset.glideDir === '=0') {
						arrow.classList.toggle('glide__bullet--active')
					}
					arrow.addEventListener('click', () => {
						const active = glide.parentNode.querySelector('.glide__bullet--active')
						if (active !== null) {
							active.classList.toggle('glide__bullet--active')
						}
						gotoSlide(carousel, arrow.dataset.glideDir)
						arrow.classList.toggle('glide__bullet--active')
					})
				})

        carousel.on('move.after', () => {
          const active = glide.parentNode.querySelector('.glide__bullet--active')
          if (active !== null) {
            active.classList.toggle('glide__bullet--active')
          }

          const index = carousel.index;
					const newLink = glide.parentNode.querySelectorAll('.link')[index];
          newLink.classList.toggle('glide__bullet--active');


        });

				carousel.mount()
			});
		}
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/product.js